import axiosInstance from "../Interceptor";
import axios from "axios";

export const getStoreListApi = (data) => {
  // console.log(payload);

   const baseUrl = process.env.REACT_APP_BASE_URL_TWO;
  return axios
    .get(`${baseUrl}users/api/v1/${data}/`)
    .then((res) => {
      // console.log(res);
      return res;
    })
    .catch((err) => {
      // console.log(err);
      return err;
    });
};
